import { chatFocusSlice } from '../store/slices/chatFocusSlice';

export const chatInFocus = chatFocusSlice.reducer;
